module.exports = __webpack_public_path__ + "static/img/17-北京十二中朗悦学校.56e3346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/17-北京十二中朗悦学校.png
// module id = mF41
// module chunks = 0